module.exports = __webpack_public_path__ + "static/sample-img-2-42ea4dd35dc4dff9c6393b8cf2554f80.png";